import React from "react";
import { PageLink, KontentRichText, ComponentProps } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { HeroEquals } from "../../elements/Equals/equals";
import {
  MediaHeroProps,
  MediaHeroWrapper,
} from "../../elements/HeroWrapper/Media";
import { SolidHeroProps } from "../../elements/HeroWrapper/Solid";
import * as styles from "./SimpleHero.module.css";
import { SimpleHeroContent } from "./SimpleHeroContent";

interface Props extends ComponentProps, MediaHeroProps {
  title: string;
  text?: KontentRichText;
  sidekick?: KontentRichText;
  cta?: PageLink;
}

export const MediaSimpleHero: React.FC<Props> = ({
  title,
  text,
  sidekick,
  cta,
  style,
  height,
  desktopImage,
  mobileImage,
  videoUrl,
  ...props
}) => {
  return (
    <SectionWrapper {...props}>
      <MediaHeroWrapper
        style={style}
        height={height}
        desktopImage={desktopImage}
        mobileImage={mobileImage}
        videoUrl={videoUrl}
      >
        <SimpleHeroContent
          title={title}
          text={text}
          cta={cta}
          style={style}
        ></SimpleHeroContent>
        <HeroEquals className={styles.equals} id={`hero${props.id}`} />
      </MediaHeroWrapper>
    </SectionWrapper>
  );
};
